import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { KommaLogo } from "@/components/komma/KommaLogo";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center bg-komma-cream" data-testid="splash-loading">
                <KommaLogo size={120} />
                <div className="mt-6 h-1 w-40 overflow-hidden rounded-full bg-komma-navy/10">
                    <div className="h-full w-1/3 bg-komma-gold animate-shimmer" style={{ backgroundSize: "200% 100%", backgroundImage: "linear-gradient(90deg,#c9a961,#0f1e4a,#c9a961)" }} />
                </div>
                <p className="mt-3 text-xs uppercase tracking-[0.3em] text-komma-navy/60">Trust · Growth · Prosperity</p>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
    return children;
}
